export default __webpack_public_path__ + "static/crous-mousse-988c296157e13bbe1709a8d1475ae0a9.jpg";